import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=25987759&scoped=true"
import script from "./Column.vue?vue&type=script&lang=js"
export * from "./Column.vue?vue&type=script&lang=js"
import style0 from "./Column.vue?vue&type=style&index=0&id=25987759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25987759",
  null
  
)

export default component.exports